import { helpers, React, ts, ui, useSelector } from '_core';

import { prepareData } from './helpers';
import { Params } from './types';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  coverageFile: string;
  fullScreen: boolean;
  title: string;
  params: Params;
  context: ts.types.riskModel.RiskModelAnalysisContext;
};

const Chart = ({ id, readOnly, loadWidgetData, coverageFile, fullScreen, title, params, context }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const resources = useSelector((store) => store.resources);
  const universe = React.useMemo(() => resources.universes.find((u) => u.id == params.analysis_universe_id), []);
  const riskModel = React.useMemo(() => resources.risk_models.find((r) => r.id == context.id), []);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: coverageFile,
          rename: { build_date: 'date' },
        },
      });

      if (response) setData(prepareData(response.data, universe, riskModel));
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (coverageFile) loadData();
    return () => setData(null);
  }, [coverageFile]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      yAxisLabel="Asset Count"
      xAxisLabel="Time"
    />
  );
};

export default Chart;
